import { render, staticRenderFns } from "./MobileDashboardHeader.vue?vue&type=template&id=04d285aa&scoped=true"
import script from "./MobileDashboardHeader.vue?vue&type=script&lang=js"
export * from "./MobileDashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileDashboardHeader.vue?vue&type=style&index=0&id=04d285aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d285aa",
  null
  
)

export default component.exports